import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { FomoStyles } from './Fomo.style';

const Clock = dynamic(() => import('../Clock/Clock'), { ssr: false });

const Fomo = ({ text }) => {
  return (
    <div className="fomo-container">
      <Clock />
      <span className="fomo-text">{text}</span>
      <style jsx>{FomoStyles}</style>
    </div>
  );
};

Fomo.propTypes = {
  text: PropTypes.string,
};

Fomo.defaultProps = {
  text: 'Últimas unidades',
};

export default Fomo;
